import { combineReducers } from "redux";

import authReducer from "./authReducer";
import clientReducer from "./clientReducer";
import therapistReducer from "./therapistReducer";
import chatReducer from "./chatReducer";
import toastReducer from "./toastReducer";
import bseReducer from "./bseReducer";
import notificationsReducer from "./notificationsReducer";
import supervisionReducer from "./supervisionReducer";
import onboardingReducer from "./onboardingReducer";
import analyticsReducer from "./analyticsNewReducer";
import commonReducer from "./commonReducer";
import calendarReducer from "./calendarReducer";
import informedConsentReducer from "./informedConsentReducer";
import groupReducer from "./groupReducer";
import mobileNavReducer from "./mobileNavReducer";
import featureFlagsReducer from "./featureFlagsReducer";
import clientProfileTabsReducer from "./clientProfileTabsReducer";
import countryCodesReducer from "./countryCodesReducer";
import twaAIReducer from "./twaAIReducer";
import aiChatReducer from "./aiChatReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  client: clientReducer,
  provider: therapistReducer,
  analytics: analyticsReducer,
  chat: chatReducer,
  toast: toastReducer,
  bse: bseReducer,
  twaAI: twaAIReducer,
  aiChat:aiChatReducer,
  notifications: notificationsReducer,
  supervision: supervisionReducer,
  onboarding: onboardingReducer,
  commonReducer: commonReducer,
  calendar: calendarReducer,
  informedConsent: informedConsentReducer,
  mobileNav: mobileNavReducer,
  featureFlags: featureFlagsReducer,
  group: groupReducer,
  clientProfileTabs: clientProfileTabsReducer,
  countryCodes: countryCodesReducer,
});
